import React from "react";

// Generic Shimmer Effect
const ShimmerEffect = ({ width = "100%", height = "16px", borderRadius = "4px", style = {} }) => (
  <div
    style={{
      width,
      height,
      borderRadius,
      background: "linear-gradient(90deg, #e0e0e0 25%, #f8f8f8 50%, #e0e0e0 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.5s infinite",
      ...style,
    }}
  />
);

// One-time keyframes injection
if (typeof window !== "undefined" && !document.getElementById("shimmer-keyframes")) {
  const shimmerAnimation = `
    @keyframes shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
  const style = document.createElement("style");
  style.id = "shimmer-keyframes";
  style.type = "text/css";
  style.innerHTML = shimmerAnimation;
  document.head.appendChild(style);
}

// Shimmer Layout UI
const ShimmerDashboard = ({onlyTable = false}) => {
  const columns = ["Date Added", "Prospect Name", "Email", "Application Status", "Last Authorization Sent", "Action"];

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", background: "#fff", height: onlyTable ? "100%":"100vh" }}>
      {/* Header Dropdowns Row */}
      {!onlyTable && <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
        <ShimmerEffect width="300px" height="35px" />
        <ShimmerEffect width="300px" height="35px" />
      </div>}

      {/* Top Cards Row */}
      {!onlyTable && <div style={{ display: "flex", gap: "16px", marginBottom: "30px" }}>
        {Array.from({ length: 1 }).map((_, i) => (
          <div key={i} style={{ flex: 1, padding: "16px", borderRadius: "8px", backgroundColor: "#f0f0f0" }}>
            <ShimmerEffect width="10%" height="14px" style={{ marginBottom: "8px" }} />
            <ShimmerEffect width="30%" height="20px" />
          </div>
        ))}
      </div> }

      {/* Tabs */}
      {!onlyTable && <div style={{ display: "flex", gap: "24px", marginBottom: "16px" }}>
        {["Dashboard", "Prospects", "Members", "Commissions"].map((tab, index) => (
          <ShimmerEffect key={index} width="120px" height="25px" />
        ))}
      </div>}

      {/* Search and Buttons */}
      {!onlyTable && <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
        <ShimmerEffect width="300px" height="35px" />
        <div style={{ display: "flex", gap: "12px" }}>
          <ShimmerEffect width="40px" height="40px" borderRadius="50%" />
          <ShimmerEffect width="40px" height="40px" borderRadius="50%" />
        </div>
      </div>}

      {/* Table */}
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {columns.map((_, index) => (
              <th
                key={index}
                style={{
                  textAlign: "left",
                  padding: "10px",
                  borderBottom: "2px solid #ccc",
                }}
              >
                <ShimmerEffect width="120px" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 10 }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((_, colIndex) => (
                <td
                  key={colIndex}
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <ShimmerEffect width="100%" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShimmerDashboard;
